var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",class:[_vm.type, _vm.visible ? 'show' : 'hide']},[_c('div',{staticClass:"content",on:{"mouseenter":function($event){_vm.mouseIn = true},"mouseleave":_vm.checkLeave}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }